import { render, staticRenderFns } from "./ContratosSigaPantalla.vue?vue&type=template&id=cf43d43e&"
import script from "./ContratosSigaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratosSigaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports